<template>
  <div id="letter-from-our-board-chair" class="section-content">
    <div class="grid-container">
      <div class="board-chair-wrapper grid-x align-center">
        <div class="cell small-10 large-8 board-chair">
          <div class="board-chair__letter"
               data-aos="fade-right"
               data-aos-delay="200"
               data-aos-duration="600"
               data-aos-offset="100">
            <h2>A Letter from our Board Chair</h2>
            <p>
              The year 2020 was a difficult one for doctors. Many cared directly for COVID-19 patients; others managed dramatic shifts in demand for services. Through all these challenges, the doctors persevered to protect and support their patients, their staffs, and their families. Thank you to these physicians for their service and dedication.
            </p>
            <p>
              As a company owned and governed by physicians, SVMIC did its best to help with the challenges created by COVID-19. Premiums were temporarily reduced for doctors sidelined by the virus, rate increases were postponed, and payment flexibility was provided for doctors under financial duress. SVMIC employees worked diligently to provide resources and personal assistance for practices. They provided guidance on a wide variety of topics including access to stimulus funds, telemedicine, human resources, infection control, practice reopening, and vaccination processes. The risk management seminar on proper prescribing practices was moved online, and all registration fees were waived.
            </p>
            <p>
              SVMIC remains committed to providing needed resources and addressing new concerns as they arise. The company is likewise committed to driving down claims costs with effective risk management education. Despite these efforts, the cost of providing superior medical malpractice coverage continues to increase due to both a multi-year upward trend in large losses and due to a steady rise in defense costs. After many years of either holding rates stable or reducing them, this year SVMIC’s board of directors approved a small increase in all states. These increases are needed to ensure that premiums collected remain in line with the cost of providing coverage.
            </p>
            <p>
              Though this decision is unwelcome, it has been clearly indicated since last year when the increase was postponed to support policyholders during the events of 2020. Now a rate increase must be taken. Be assured, this decision was made carefully, thoughtfully, and with the use of extensive analytics.
            </p>
            <p>
              As we face the challenges of this new year, please know that SVMIC is here to support its policyholders. Please contact us immediately with any comments or questions.
            </p>
            <div class="board-chair__signature">
              <div class="board-chair__signature__photo"
                 data-aos="zoom-out"
                 data-aos-delay="200"
                 data-aos-duration="1000"
                 data-aos-offset="100">
                <img src="../../assets/hugh.png"
                   alt="Chair of the Board"/>
              </div>
              <div class="board-chair__signature__subtext"
                 data-aos="fade-in"
                 data-aos-delay="400"
                 data-aos-duration="1000"
                 data-aos-offset="100">
              <h5>Hugh Francis, III, MD</h5>
              <p>Chair of the Board</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeLetter'
};
</script>
